import ascending from "./ascending.js";

export default function(series) {
  return ascending(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-shape/src/order/descending.js
// module id = ./node_modules/d3-shape/src/order/descending.js
// module chunks = vendor